import { createGlobalStyle } from 'styled-components';

const StepperStyles = createGlobalStyle`
.steppers {
  padding: 8px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 32px 32px;
  z-index: 100;
  margin: auto;
  width: 100%;
  position: relative;
}

.steppers .text {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;
  color: #6f7072;
  margin-bottom: 12px;
}

.steppers .stepper-content {
  display: flex;
}

.steppers .stepper-content .stepper-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #6f7072;
  font-weight: 300;
}

.steppers .stepper-content hr {
  display: none;
}
.steppers .stepper-content .stepper-item .stepper-item-num {
  margin-bottom: 4px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.steppers .stepper-content .stepper-item .stepper-item-num svg path {
  fill: #a0a0a0;
}

.steppers
  .stepper-content
  .stepper-item:not(:first-child)
  .stepper-item-num:before {
  content: "";
  width: calc(100% - 32px);
  position: absolute;
  height: 2px;
  border-radius: 1px;
  background: #cccccc;
  top: 50%;
  margin-top: -1px;
  right: 50%;
  margin-right: 16px;
}

.steppers .stepper-content .stepper-item .stepper-item-num .completed {
  display: none;
}

.steppers
  .stepper-content
  .stepper-item:not(:first-child).active
  .stepper-item-num:before {
  background: #c21b17;
}

.steppers .stepper-content .stepper-item p {
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  color: inherit;
  margin: 0px;
}

.steppers .stepper-content .stepper-item.active {
  color: #c21b17;
  font-weight: 500;
}

.steppers .stepper-content .stepper-item.active svg path {
  fill: #c21b17;
}

.steppers
  .stepper-content
  .stepper-item:not(:first-child).completed
  .stepper-item-num:before {
  background: #00d764;
}

.steppers .stepper-content .stepper-item.completed {
  color: #6f7072;
  font-weight: 300;
}

.steppers .stepper-content .stepper-item.completed svg {
  display: none;
}

.steppers .stepper-content .stepper-item.completed .stepper-item-num img {
  display: block;
}

@media screen and (min-width: 576px) {
  .steppers .text br {
    display: none;
  }
  .stepper-content {
    padding: 16px;
    align-items: center;
  }
  .steppers .stepper-content hr {
    display: block;
    margin: 0px;
    flex: 1;
  }

  .steppers .stepper-content .stepper-item {
    flex-direction: row;
    align-items: center;
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 32px;
    flex: unset;
    width: fit-content;
    padding: 6px 12px 6px 6px;
    position: relative;
    z-index: 1;
  }

  .steppers .stepper-content .stepper-item.active {
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.02), 0px 2px 4px rgba(0, 0, 0, 0.2);
    border: none;
  }

  .steppers .stepper-content .stepper-item.completed{
    border-color:#00d764
  }

  .steppers .stepper-content .stepper-item.completed + hr {
    background: #c21b17;
  }

  .steppers .stepper-content .stepper-item.completed:nth-child(2) + hr:first-child {
    background: #00d764;
  }

  .steppers .stepper-content .stepper-item .stepper-item-num {
    width: auto;
    margin: 0;
  }

  .steppers .stepper-content .stepper-item p {
    margin: 0px;
    margin-left: 8px;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.01em;
    font-weight: 700;
  }
  .steppers .stepper-content .stepper-item br {
    display: none;
  }
}

`;

export default StepperStyles;
